import { myAxios } from "./axios"

export function getPriceComponents(data, { page, perPage }) {
    let config = {
        params: {
            page,
            perPage,
            ...(data || {})

        },
    }
    return myAxios.get("/price-components", config)
}

export function getRelatedPriceComponents(data, { page, perPage }) {
    let config = {
        params: {
            page,
            perPage,
            ...(data || {})

        },
    }
    return myAxios.get("/"+data.type+"/"+data.id+"/price-components", config)
}

export function getPriceComponent(id) {
    return myAxios.get("/price-components/" + id)
}

export function addPriceComponent(data) {
    return myAxios.post("/price-components/create", data)
}

export function editPriceComponent(id, data) {
    return myAxios.put("/price-components/" + id + "/update", data)
}

export function deletePriceComponent(id) {
    return myAxios.delete("/price-components/" + id + "/delete")
}



export function assignPriceComponent(data) {
    return myAxios.post("/price-components/assign", data)
}
export function deassignPriceComponent(data) {
    return myAxios.post("/price-components/deassign", data)
}